import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=722cda8f&scoped=true&"
import script from "./UserEditDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditDetails.vue?vue&type=style&index=0&id=722cda8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722cda8f",
  null
  
)

export default component.exports